module.exports = __webpack_public_path__ + "img/202509_05.f8895164.jpg";